<template>
  <div v-if="sputum" class="card card-content">
    <h6>Sputum</h6>
    <form>
      <div class="row">
        <div class="input-field col s12">
          <div class="switch">
            <label>
              Not Done
              <input
                type="checkbox"
                @click="switchChange"
                :checked="sputum.done == 1"
              />
              <span class="lever"></span>
              Done
            </label>
          </div>
        </div>
        <div class="input-field col s12">
          <span>Date of Sputum Smear examination</span>
          <input
            :disabled="sputum.done != 1"
            type="text"
            placeholder="YYYY-MM-DD"
            v-model.lazy="sputum.date"
            class="datepicker"
            readonly
          />
        </div>
        <div class="input-field col s12" v-show="sputum.done == 1">
          <span>Sputum Smear Result</span>
          <select v-model="sputum.result">
            <option value="" disabled selected>Choose your option</option>
            <option value="1">Negative</option>
            <option value="2">Positive</option>
            <option value="3">Missing</option>
            <option value="4">Pending</option>
          </select>
        </div>

        <div class="row center" v-if="buttonpass">
          <button
            type="button"
            class="btn blue darken-3"
            @click="submit"
            :disabled="updateloading"
          >
            Edit
          </button>
        </div>
      </div>
    </form>
  </div>
  <new-sputum-xray v-else></new-sputum-xray>
</template>

<script>
import NewSputum from "@/components/Patient/Fill/Sputum/NewSputum.vue";
export default {
  name: "Sputum",
  data() {
    return {
      done: false,
      date: "",
      result: "",
    };
  },
  components: {
    "new-sputum-xray": NewSputum,
  },
  mounted() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems, {});

    var elems = document.querySelectorAll(".datepicker");
    var instances = M.Datepicker.init(elems, {
      format: "yyyy-mm-dd",
      showClearBtn: true,
    });
  },
  watch: {},
  methods: {
    switchChange() {
      this.sputum.done = this.sputum.done == 0 ? 1 : 0;
    },

    submit() {
      var data = {
        done: this.sputum.done,
        date: null,
        result: null,
      };

      if (data.done) {
        data.date = this.sputum.date;
        data.result = this.sputum.result;
      }

      data.id = this.patient.id;

      this.$store.dispatch("submitSputum", data);
    },
  },

  computed: {
    patient() {
      return this.$store.getters.patient;
    },

    sputum() {
      var item = localStorage.getItem("current_data");
      var data = this.$store.getters.patient.sputum;
      if (!item) {
        localStorage.setItem("current_data", JSON.stringify(data));
      }

      return data;
    },

    buttonpass() {
      if (this.sputum.done == 1) {
        if (this.sputum.result && this.sputum.date) {
          return true;
        } else if (this.sputum.result == 4) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    updateloading() {
      return this.$store.getters.updateloading;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fill {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
}

.fill .card {
  padding: 20px;
}
</style>
